import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `settingsReferrals:` scope (F72), following
 * the exact `driveSettings:`/`shares:` precedent (`apps/web/src/routes/
 * settings/drive/drive.i18n.ts`) — NOT a second i18n runtime (E18/§13.3
 * ban), just physically scoped here because `packages/i18n/**` is outside
 * this task's ownership boundary. Deliberately does NOT touch
 * `apps/web/src/routes/settings/settings.i18n.ts` (shared file, `nav.referrals`
 * already added there by a different pass) — every OTHER referral-tab
 * string lives in this colocated catalog instead.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/settingsReferrals.json`.
 */
const en = {
  'title': 'Referrals',
  'description': 'Share a document — when someone joins or upgrades through it, you earn {count, plural, one {# credit} other {# credits}}.',
  'cta.label': 'Share a document',
  'stats.invited.label': 'Invited',
  'stats.joined.label': 'Joined',
  'stats.creditsEarned.label': 'Credits earned',
  'stats.error.title': "Couldn't load your referral stats.",
  'stats.action.retry': 'Retry',
  'panel.title': 'Referral status',
} as const;

const ro: Record<keyof typeof en, string> = {
  'title': 'Recomandări',
  'description': 'Distribuie un document — când cineva se alătură sau face upgrade prin el, câștigi {count, plural, one {# credit} few {# credite} other {# de credite}}.',
  'cta.label': 'Distribuie un document',
  'stats.invited.label': 'Invitați',
  'stats.joined.label': 'Alăturați',
  'stats.creditsEarned.label': 'Credite câștigate',
  'stats.error.title': 'Nu am putut încărca statisticile de recomandare.',
  'stats.action.retry': 'Reîncearcă',
  'panel.title': 'Status recomandări',
};

export const SETTINGS_REFERRALS_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type SettingsReferralsCatalogKey = keyof typeof en;
